import React from "react";
import { ArrowRight, Gauge } from "lucide-react";

const HERO_WELDING =
  "https://images.unsplash.com/photo-1564182998523-6923112e7d6b?auto=format&fit=crop&w=900&q=80";
const SAFETY_WELDER =
  "https://images.unsplash.com/photo-1762786219193-f34607f29d38?auto=format&fit=crop&w=900&q=80";

const PRODUCTS = [
  {
    name: "Cilindros Industriales",
    desc: "Cilindros de alta presión para gases industriales en diferentes capacidades.",
    type: "image",
    image:
      "https://images.pexels.com/photos/16271901/pexels-photo-16271901.jpeg?auto=compress&cs=tinysrgb&w=800",
    tag: "Industrial",
  },
  {
    name: "Tanques de Oxígeno",
    desc: "Tanques de oxígeno medicinal e industrial certificados para uso seguro.",
    type: "image",
    image:
      "https://customer-assets.emergentagent.com/job_cima-industrial/artifacts/odihsxhs_image.png",
    tag: "Médico · Industrial",
  },
  {
    name: "Reguladores de Presión",
    desc: "Reguladores precisos para oxígeno, argón, CO₂ y mezclas de soldadura.",
    type: "image",
    image:
      "https://customer-assets.emergentagent.com/job_cima-industrial/artifacts/ucbp9q8p_image.png",
    tag: "Equipo",
    imageBg: "white",
  },
  {
    name: "Equipos de Soldadura",
    desc: "Antorchas, mangueras y accesorios profesionales para soldadura MIG, TIG y oxicorte.",
    type: "image",
    image: HERO_WELDING,
    tag: "Soldadura",
  },
  {
    name: "Accesorios Industriales y Médicos",
    desc: "Conexiones, válvulas, máscaras, mangueras y todo lo necesario para tu operación.",
    type: "image",
    image: SAFETY_WELDER,
    tag: "Accesorios",
  },
];

const ACCENT_BG = {
  red: "bg-gradient-to-br from-[#D90429] via-[#B0001E] to-[#0F172A]",
  orange: "bg-gradient-to-br from-[#EA580C] via-[#C2410C] to-[#0F172A]",
  navy: "bg-gradient-to-br from-[#0F172A] via-[#1E293B] to-[#0F172A]",
};

export default function Products({ onOpenQuote }) {
  return (
    <section id="productos" data-testid="products-section" className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">
          <div>
            <span className="divider-orange mb-5" />
            <p className="font-mono-cima text-xs uppercase tracking-widest text-[var(--cima-red)] mb-3">
              Catálogo
            </p>
            <h2 className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl leading-tight text-[var(--cima-navy)]">
              Productos destacados
            </h2>
          </div>
          <p className="max-w-md text-slate-600">
            Equipos confiables y de alta calidad, seleccionados para cumplir con los estándares
            industriales y médicos más exigentes.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
          {PRODUCTS.map((p, i) => (
            <article
              key={p.name}
              data-testid={`product-card-${i}`}
              className="sharp-card overflow-hidden flex flex-col group"
            >
              <div className="relative aspect-[4/3] overflow-hidden bg-slate-100">
                {p.type === "image" ? (
                  <img
                    src={p.image}
                    alt={p.name}
                    loading="lazy"
                    className={`w-full h-full ${p.imageBg === "white" ? "object-contain bg-white p-6" : "object-cover"} group-hover:scale-105 transition-transform duration-700`}
                  />
                ) : (
                  <div
                    className={`relative w-full h-full ${ACCENT_BG[p.accent]} grain-overlay flex items-center justify-center`}
                  >
                    <p.icon className="w-24 h-24 text-white/90 stroke-1" strokeWidth={1.2} />
                    <div className="absolute -bottom-4 -right-4 w-24 h-24 stripe-accent opacity-50 rotate-12" />
                    <div className="absolute top-0 left-0 w-1 h-full bg-white/20" />
                  </div>
                )}
                <div className="absolute top-3 left-3 bg-white/95 border border-slate-200 px-2.5 py-1 text-[10px] font-mono-cima uppercase tracking-widest text-slate-700">
                  {p.tag}
                </div>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="font-display font-semibold text-xl text-[var(--cima-navy)] leading-tight">
                  {p.name}
                </h3>
                <p className="text-sm text-slate-600 mt-2 flex-1">{p.desc}</p>
                <button
                  data-testid={`product-quote-${i}`}
                  onClick={() => onOpenQuote(p.name)}
                  className="mt-5 inline-flex items-center justify-between gap-2 px-4 py-3 border border-slate-300 text-sm font-semibold text-[var(--cima-navy)] hover:border-[var(--cima-red)] hover:text-[var(--cima-red)] transition-colors"
                >
                  Solicitar Cotización
                  <ArrowRight className="w-4 h-4" />
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
